<InactivityModal />

<!-- App shell: navbar + sidebar fixed; only content scrolls -->
<div class="vh-100 d-flex flex-column bg-gray overflow-hidden">

  <!-- Navbar (same component & behavior) -->
  <Navbar
    @sidebar-toggle="toggleSidebar"
    class="navbar navbar-expand-lg sticky-top bg-white border-bottom w-100 p-0 m-0">
  </Navbar>

  <!-- Main area below navbar fills remaining height -->
  <div class="container-fluid flex-grow-1 overflow-hidden">
    <div class="row h-100">

      <!-- Sidebar column (same Sidebar component; no scrolling) -->
      <div class="col-auto bg-white h-100 d-none d-lg-block rounded-end mt-2">
        <div class="mt-2">
          <Sidebar ref="sidebar"></Sidebar>
        </div>
      </div>
      <!-- Content column (the ONLY scrollable area) -->
      <div class="col h-100 overflow-auto mt-2">

        <!-- Group card -->
        <div class="visitor-card shadow border-primary">
          <div class="card-body bg-white pt-2">

            <!-- Actions header (sticky within scrollable content) -->
            <div class="d-flex justify-content-between align-items-center sticky-top">
              <button class="btn btn-primary text-white btn-sm text-xxs rounded-3 shadow-lg fw-500 mt-2"
                data-bs-toggle="modal"
                data-bs-target="#create_group_modal">
                <i class='bx bx-plus'></i> Create Group
              </button>
            </div>
          </div>

          <!-- group table -->
           <div v-if="isLoading" class="text-center py-5 w-100">
              <div class="spinner-border text-secondary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <p class="mt-2 mb-0 text-muted text-xxs">Loading Group List...</p>
            </div>
            <div v-else>
          <div class="card-body table-responsive mt-2">
            <table class="table table-striped text-xxs mt-3">
              <thead class="bg-primary text-white">
                <tr>
                  <th class="text-xxs fw-light text-center">No.</th>
                  <th scope="col">Group Name</th>
                  <th scope="col">Created By</th>
                  <th scope="col">Is Private</th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(group, index) in groups" :key="group.id">
                  <th scope="row">{{ index + 1 }}</th>
                  <td>{{ group.name }}</td>
                  <td>{{ group?.created_by?.first_name }} {{ group?.created_by?.last_name }}</td>
                  <td>{{ group.is_public? 'Public' : 'Private' }}</td>
                  <td>
                    <button class="btn btn-primary text-xxs rounded-5 mx-1 btn-sm shadow d-none">
                      <i class="bi bi-eye"></i> View
                    </button>
                    <button class="btn btn-light btn-sm rounded-3 text-success border text-xxs me-1" data-bs-toggle="modal"
                        data-bs-target="#create_group_modal"
                        @click="open_edit_group_modal(group)">
                      Edit
                    </button>
                    <button @click="deleteGroup(group.id)" class="btn btn-light btn-sm rounded-3 text-danger border text-xxs">
                      Delete
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          </div>

    <teleport to="body">
      <div class="modal fade" id="create_group_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header bg-primary text-white position-relative">
              <p class="modal-title text-xs test fw-500" id="exampleModalLabel">
                {{ editing ? 'Edit Group' : 'Create a Group' }}
              </p>
              <button type="button" class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <form @submit.prevent="handle_submit">
              <div class="modal-body">
                <div class="mb-3">
                  <label for="group_name" class="form-label text-xs fw-500">Group Name <span
                      class="text-danger">*</span></label>
                  <input type="text" class="form-control rounded-5 text-xs" id="group_name" v-model="group_name"
                    placeholder="Enter group name">
                  <p v-if="errors.group_name" class="text-danger text-xs">{{ errors.group_name }}</p>
                </div>

                <div
                  class="d-flex flex-start">
                  <select class="btn btn-sm btn-outline-secondary text-xxs px-4 py-1 mb-1" v-model="selectedPortalId">
                    <option value="" selected hidden>Tag a portal</option>
                    <option v-for="portal in portals" :value="portal.id" :key="portal.id">
                      {{ portal.name }}
                    </option>
                  </select>
                  <p v-if="errors.portal" class="text-danger text-xs mt-1 mb-0">{{ errors.portal }}</p>
                </div>
                <div class="mb-3">
                  <label for="group_description" class="form-label text-xs fw-500">Group Description</label>
                  <textarea class="form-control rounded-5 text-xs" id="group_description" v-model="group_description"
                    placeholder="Enter group description"></textarea>
                </div>
                <div class="mb-3">
                  <label for="is_public" class="form-label text-xs fw-500">Visibility <span
                      class="text-danger">*</span></label>
                  <select class="form-select rounded-5 text-xs" id="is_public" v-model="is_public" required>
                    <option selected hidden>Select visibility type</option>
                    <option value="true">Public</option>
                    <option value="false">Private</option>
                  </select>
                </div>

              </div>
              <div class="modal-footer">
                <button type="submit" class="btn btn-primary text-xs rounded-5">
                  {{ editing ? 'Update' : 'Post' }}
                </button>
              </div>
              </form>
            </div>
          </div>
        </div>
        </teleport>
        </div>
      </div>
    </div>
  </div>
</div>